import { EnableWidget } from './enable-widget.model';

export class EnableWidgetGroup {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    image: string;
    imageHeightPx: 40;
    widgets: EnableWidget[] = [];
}
